import { useState } from 'react'
import {
  Users,
  Award,
  TrendingUp,
  CheckCircle,
  Star,
  Zap,
  Briefcase,
  Calendar,
  Scale,
  FileText,
  Shield,
  DollarSign,
  Building,
  BookOpen,
  Mail,
  Phone,
  Globe,
  Clock,
  MapPin,
  Headphones,
  MessageCircle,
} from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { cn } from '@/lib/utils'

const ICONS = [
  { lucide: 'Users', label: 'Usuarios', Icon: Users },
  { lucide: 'Award', label: 'Premio', Icon: Award },
  { lucide: 'TrendingUp', label: 'Tendencia', Icon: TrendingUp },
  { lucide: 'CheckCircle', label: 'Check', Icon: CheckCircle },
  { lucide: 'Star', label: 'Estrella', Icon: Star },
  { lucide: 'Zap', label: 'Energía', Icon: Zap },
  { lucide: 'Briefcase', label: 'Maletín', Icon: Briefcase },
  { lucide: 'Calendar', label: 'Calendario', Icon: Calendar },
  { lucide: 'Scale', label: 'Balanza', Icon: Scale },
  { lucide: 'FileText', label: 'Documento', Icon: FileText },
  { lucide: 'Shield', label: 'Escudo', Icon: Shield },
  { lucide: 'DollarSign', label: 'Dinero', Icon: DollarSign },
  { lucide: 'Building', label: 'Edificio', Icon: Building },
  { lucide: 'BookOpen', label: 'Libro', Icon: BookOpen },
  { lucide: 'Mail', label: 'Email', Icon: Mail },
  { lucide: 'Phone', label: 'Teléfono', Icon: Phone },
  { lucide: 'Globe', label: 'Globo', Icon: Globe },
  { lucide: 'Clock', label: 'Reloj', Icon: Clock },
  { lucide: 'MapPin', label: 'Ubicación', Icon: MapPin },
  { lucide: 'Headphones', label: 'Soporte', Icon: Headphones },
  { lucide: 'MessageCircle', label: 'Chat', Icon: MessageCircle },
]

function IconPicker({ value, onChange, label = 'Icono' }) {
  const [open, setOpen] = useState(false)
  const selected = ICONS.find((i) => i.lucide === value)
  const SelectedIcon = selected?.Icon || Zap

  return (
    <div>
      <p className="text-caption text-neutral-500 dark:text-neutral-400 mb-1.5">{label}</p>
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={() => setOpen(true)}
        className="w-full justify-start"
      >
        <SelectedIcon size={16} />
        <span className="truncate">{selected?.label || 'Elegir'}</span>
      </Button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>Elige un icono</DialogTitle>
          </DialogHeader>
          <div className="grid grid-cols-4 sm:grid-cols-6 gap-2">
            {ICONS.map(({ lucide, label, Icon }) => {
              const active = lucide === value
              return (
                <button
                  key={lucide}
                  type="button"
                  onClick={() => {
                    onChange(lucide)
                    setOpen(false)
                  }}
                  className={cn(
                    'flex flex-col items-center justify-center gap-1 rounded-md border p-2.5 text-neutral-700 dark:text-neutral-300 transition-all min-h-[72px]',
                    active
                      ? 'border-primary bg-primary-50 dark:bg-primary-900/40 text-primary-700 dark:text-primary-300'
                      : 'border-neutral-200 dark:border-neutral-800 hover:border-primary-300 dark:hover:border-primary-700 hover:bg-neutral-50 dark:hover:bg-neutral-800/60'
                  )}
                  title={label}
                >
                  <Icon size={20} />
                  <span className="text-micro truncate w-full text-center">{label}</span>
                </button>
              )
            })}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default IconPicker
